import styled from 'styled-components';
import { Icon } from './Icon';
const CircleIcon = styled(Icon) `
  && {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.ThemeColors.BACKGROUND_COLOR.hex};
    border: 1px solid ${({ theme }) => theme.ThemeColors.BORDER.hex};
    color: ${({ theme }) => theme.ThemeColors.TEXT.hex};
    min-width: ${({ fontSize }) => fontSize ? `${Number.parseFloat(fontSize) * 1.5}rem` : '1.5rem'};
    padding: ${({ fontSize }) => fontSize ? `${Number.parseFloat(fontSize) / 6}rem` : '0.25rem'}; 
    line-height: normal;
    -webkit-text-stroke-width: 1px;
  }
`;
export { CircleIcon };
